/**
 * Implementation of the Home page.
 *
 * Copyright © Ircam Amplify 2024-2026
 */
import GetStartedContainer from '@/components/GetStarted/GetStartedContainer'
import HomeAiMusicDetector from '@/components/HomePageModule/AiMusicDetector/HomeAiMusicDectector'
import HomeStereoToSpatial from '@/components/HomePageModule/StereoToSpatial/HomeStereoToSpatial'
import { logger } from '@/config/logger'
import { useSelector } from '@/store'
import { TierType } from '@amplify3/duplo-back-end'
import { Box, LinearProgress } from '@mui/material'
import { useEffect } from 'react'
import { fetchCompanyConsumption, fetchUser } from '../api'
import './HomePage.css'

export const HomePage = () => {
  useEffect(() => {
    try {
      fetchCompanyConsumption()
      fetchUser()
    } catch (e) {
      console.log('Error in HomePage', e)
    }
  }, [])

  const strTier = useSelector(
    (s) => s.user.companyConsumption?.subscription_tier
  )
  let userTier = TierType.Unknown
  try {
    userTier = strTier as TierType
  } catch (e) {
    logger.error(`Invalid subscription tier: ${e}`)
  }

  const showStereoToSpatial = userTier !== TierType.TopUpCreditAimd

  const LoadingProgress = () => {
    return (
      <Box className="loadingContainer">
        <LinearProgress className="loadingBar" />
      </Box>
    )
  }

  return (
    <div className="homePage">
      {!userTier ? (
        <LoadingProgress />
      ) : (
        <div>
          <div
            className={
              showStereoToSpatial
                ? 'start-basics-container--two'
                : 'start-basics-container--one'
            }
          >
            <HomeAiMusicDetector
              id="home-page-module-ai-music-detector"
              tier={userTier}
            />
            {showStereoToSpatial && (
              <HomeStereoToSpatial id="home-page-module-stero-to-spatial" />
            )}
          </div>

          <h2>Everything for your API integration</h2>
          <GetStartedContainer></GetStartedContainer>
        </div>
      )}
    </div>
  )
}
